// extracted by mini-css-extract-plugin
export default {"container":"ak8Mpz","mobileFilterButton":"j2tma7","mobileFontSize":"GSWnVK","mobileFilterButtonText":"IT7S32","desktopSpacing":"qFFMYd"};